// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  info: [],
  single: {},
  error: null,
};
const TeamReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TEAM":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        allData: action.data,
      };
    case "GET_ALL_TEAM":
      return {
        ...state,
        allData: action.data,
        data: action.data,
        params: action.params,
        total: action.totalPages,
      };
    case "GET_TEAM_ID":
      return {
        ...state,
        single: action.data,
      };
    case "EMPTY_ERROR":
    case "ADD_TEAM_SUCCESS":
    case "EDIT_TEAM_SUCCESS":
      return { ...state, error: null };
    case "ADD_TEAM_FAIL":
    case "EDIT_TEAM_FAIL":
      return { ...state, error: action.payload };

    default:
      return { ...state };
  }
};

export default TeamReducer;
